import { useEffect, useState } from "react";

const mediaQuery = "(prefers-color-scheme: dark)";

export default function usePrefersDarkMode() {
  const getPref = () => {
    if (typeof window === "undefined" || !window.matchMedia) {
      return false;
    }
    return window.matchMedia(mediaQuery).matches;
  };

  const [prefersDark, setPrefersDark] = useState(getPref);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(mediaQuery);
    const listener = (event) => setPrefersDark(event.matches);

    if (mql.addEventListener) {
      mql.addEventListener("change", listener);
    } else {
      mql.addListener(listener);
    }

    return () => {
      if (mql.removeEventListener) {
        mql.removeEventListener("change", listener);
      } else {
        mql.removeListener(listener);
      }
    };
  }, []);

  return prefersDark;
}
